module.exports = __webpack_public_path__ + "img/italy-ischemic-heart-disease-female.ecaae0ed.png";